import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { createTreasuryAccount } from '../treasuryAccountsEndpoints'
import { treasuryAccountKeys } from '../treasuryAccountsQueryKeys'

export function useCreateTreasuryAccountMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createTreasuryAccount,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: treasuryAccountKeys.lists() })
    },
  })
}
